import PropTypes from 'prop-types'
import React from 'react'
import { BaseApi } from 'Core/api/BaseApi'
import withTranslation from 'next-translate/withTranslation'
import { connect } from 'react-redux'
import { setCurrentGroup, setIsGroupPage } from '../src/modules/groups/actions'
import { setIsCategoryPage, fetchCategory, setCategoriesAndGroups } from '../src/modules/categories/actions'
import { getCurrentSubCategory } from '../src/modules/categories/selectors'
import { getCurrentGroup } from '../src/modules/groups/selectors'
import { deepCopy } from '../src/utils'
import { adsTypes, globalOptions } from '../src/core/constants'
import { fetchAds } from '../src/modules/ads/list/actions'
import { fetchBrands } from '../src/modules/ads/brands/actions'
import { fetchProducts, setProducts } from '../src/modules/ads/products/actions'
import { fetchCitiesByCountryWithinRegions } from '../src/modules/geoObjects/cities/actions'
import { AdsList } from '../src/modules/ads/list/components'
import { PanelMobile } from '../src/modules/ads/list/components/PanelMobile'
import { SearchPagination } from '../src/modules/ads/pagination/components'
import { AdsHeader, UserAdsFilter } from '../src/modules/ads/filter/components'
import { GroupsMenuMobile } from '../src/modules/categories/components'
import { BottomNavigation } from '../src/modules/layout/BottomNavigation'
import { Page } from '../src/ui'
import { fetchServices } from '../src/modules/ads/services/actions'
import { fetchServiceTypes, setServiceTypes } from '../src/modules/ads/serviceTypes/actions'
import { getParsedFilterValues } from '../src/modules/ads/filter/functions'
import { fetchInfo, setInfo } from '../src/modules/users/detail/actions'
import { getInfo } from '../src/modules/users/detail/selectors'
import { fetchPageMetaTags } from '../src/modules/common/actions'
import initialState from '../src/modules/redux/initialState'
import config from '../src/config/config.json'

class SearchPage extends React.Component {
  static async getInitialProps({ store, req, query, isServer }) {
    console.log('SearchPage query', query)
    let state = store.getState()
    const categoryInUrl = query.category

    const isMobileDevice = state.common.isMobileDevice

    const type = adsTypes.all

    const limit = !isMobileDevice ? globalOptions.adsCountPerPage : globalOptions.adsCountPerPageMobile

    const status = 'Published'
    let userType = query.userType

    if (isNaN(Number(query.userType))) {
      const findUserType = state.common.userTypes.find(item => item.seo === query.userType)
      if (findUserType) userType = findUserType.id
    }

    let page = 1
    const isUserSearch = Boolean(query.username)

    if (req && req.query.pageNumber) {
      page = Number(req.query.pageNumber)
    } else {
      if (query.pageNumber) page = query.pageNumber
    }

    await store.dispatch(setCategoriesAndGroups(categoryInUrl, query?.locale?.toUpperCase()))

    state = store.getState()

    const currentGroup = getCurrentGroup(state)
    const currentSubcategory = getCurrentSubCategory(state)

    let category, isGroupPage, isCategoryPage
    let adsRequestOptions = { page, type, limit, status }

    if (currentSubcategory) {
      category = currentSubcategory
      adsRequestOptions.category = category.id
      isGroupPage = false
      isCategoryPage = true
      await store.dispatch(fetchPageMetaTags({ category: currentSubcategory.id }, query?.locale?.toUpperCase()))
    } else {
      if (currentGroup && !isUserSearch) {
        adsRequestOptions.group = currentGroup.id
        await store.dispatch(fetchPageMetaTags({ group: currentGroup.id }, query?.locale?.toUpperCase()))
        isGroupPage = true
        isCategoryPage = false
      }
    }

    if (userType) adsRequestOptions.userType = userType

    if (isCategoryPage) {
      const brand = isServer ? req.query.brand : query.brand

      if (brand && category.id) await store.dispatch(fetchProducts({ brand: Number(brand), category: category.id }))
      else store.dispatch(setProducts([]))

      const service = isServer ? req.query.service : query.service
      const serviceType = isServer ? req.query.serviceType : query.serviceType

      if (service && category.id) {
        await store.dispatch(fetchServiceTypes({
          service: Number(service),
          serviceType: Number(serviceType),
          category: category.id
        }))
      } else {
        store.dispatch(setServiceTypes([]))
      }
    }

    if (isUserSearch) {
      const userRequestParams = { username: query.username }
      await store.dispatch(fetchInfo(userRequestParams))

      const userInfo = getInfo(store.getState())
      if (userInfo && userInfo.id) adsRequestOptions.adUser = userInfo.id
    } else {
      store.dispatch(setInfo(null))
    }

    const paginationParams = {
      ...store.getState().ads.pagination.params,
      currentPage: Number(page),
      adsType: type
    }

    const formStyle = isServer ? req.query.formStyle : query.formStyle

    const pageMetaTags = store.getState().common.pageMetaTagsSingle

    const possibleValues = (query['0'] || '').split('/')
    let pageUrlItems = []

    if (Array.isArray(possibleValues) && possibleValues.length && currentSubcategory) {
      const pageUrlItemsResponse = await BaseApi.post(`/v2/misc/getSearchPageUrlItems`, {
        items: possibleValues,
        category: currentSubcategory.id,
        locale: query?.locale?.toUpperCase() || 'ME'
      })

      if (pageUrlItemsResponse?.body?.items) pageUrlItems = pageUrlItemsResponse.body.items
    }

    const parsedFilterValues = getParsedFilterValues({
      filterValues: query,
      pageMetaTags,
      pageUrlItems,
      possibleValues: (query['0'] || '').split('/'),
      locale: query?.locale?.toUpperCase() || 'ME'
    })

    store.dispatch(setIsGroupPage(isGroupPage))
    store.dispatch(setIsCategoryPage(isCategoryPage))

    if (!parsedFilterValues.sortBy) parsedFilterValues.sortBy = 'dateDesc'

    await store.dispatch(fetchAds({
      ...parsedFilterValues,
      ...adsRequestOptions,
      locale: query?.locale?.toUpperCase() || 'ME'
    }, paginationParams))

    const filterValues = { ...parsedFilterValues }
    if (adsRequestOptions.userType) filterValues.userType = adsRequestOptions.userType
    if (adsRequestOptions.adUser) filterValues.adUser = adsRequestOptions.adUser
    if (adsRequestOptions.group) filterValues.group = adsRequestOptions.group
    if (adsRequestOptions.category) filterValues.category = adsRequestOptions.category

    return {
      title: category && category.title
        ? `${config.pages.category.title} - ${category.title} | ${config.pages.defaultTitle}`
        : `${config.pages.category.title} | ${config.pages.defaultTitle}`,
      isPageExists: true,
      isUserSearch,
      filterValues,
      isMobileDevice,
      formStyle,
      pageUrlItems,
      state: SearchPage.getPageState(store, isUserSearch)
    }
  }

  static getPageState(store, isUserSearch) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes
      state.user.detail = currentState.user.detail
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = false
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle
      if (!state.common.pageMetaTagsSingle) state.common.pageMetaTags = currentState.common.pageMetaTags

      state.groups = currentState.groups

      if (isUserSearch) {
        state.categories.activeCategories = currentState.categories.activeCategories
      }

      state.categories.elements = currentState.categories.elements
      state.categories.currentSubcategory = currentState.categories.currentSubcategory
      state.categories.groupCategories = currentState.categories.groupCategories

      state.ads.list = currentState.ads.list
      state.ads.pagination = currentState.ads.pagination
      state.ads.brands = currentState.ads.brands
      state.ads.products = currentState.ads.products
      state.ads.equipment = currentState.ads.equipment
      state.ads.services = currentState.ads.services
      state.ads.serviceTypes = currentState.ads.serviceTypes
      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.form = currentState.form
    }
    return state
  }

  render() {
    const { isUserSearch, filterValues, formStyle, isMobileDevice, pageUrlItems, i18n: { t } } = this.props

    return (
      <Page>
        {isUserSearch
          ? (
            <UserAdsFilter
              filterValues={filterValues}
              formStyle={formStyle}
            />
          ) : !isMobileDevice
            ? (
              <AdsHeader
                filterValues={filterValues}
                formStyle={formStyle}
              />
            ) : <GroupsMenuMobile />
        }

        {isMobileDevice ? <PanelMobile filterValues={filterValues} formStyle={formStyle} /> : null}

        <AdsList
          noAdsMessage={t('common:noAdsMessage')}
          isSearchPage
          filterValues={filterValues}
          formStyle={formStyle}
          isUserSearch={isUserSearch}
          pageUrlItems={pageUrlItems}
        />
        <SearchPagination isUserSearch={isUserSearch} filterValues={filterValues} formStyle={formStyle} />
        {isMobileDevice ? <BottomNavigation /> : null}
      </Page>
    )
  }
}

SearchPage.propTypes = {
  isUserSearch: PropTypes.bool.isRequired,
  filterValues: PropTypes.object.isRequired,
  formStyle: PropTypes.string.isRequired,
  pageUrlItems: PropTypes.object
}

SearchPage.defaultProps = {
  isUserSearch: false
}

export default withTranslation(SearchPage)
